import { ENV } from "@/enum/system";

import { SDKConfig } from "./base";

// 基础配置类型
export interface BaseSDKConfig extends SDKConfig {
  enabled: boolean;
  key?: string;
  multipleInstances?: boolean;
}

// Google Analytics 配置
export interface GoogleAnalyticsConfig extends BaseSDKConfig {
  trackingId: string;
}

// Hotjar 配置
export interface HotjarConfig extends BaseSDKConfig {
  siteId: number;
  sv: number;
}

// Sentry 配置
export interface SentryConfig extends BaseSDKConfig {
  dsn: string;
  environment: ENV;
}

// Adjust 配置
export interface AdjustConfig extends BaseSDKConfig {
  appToken: string;
}

// Facebook 配置
export interface FacebookConfig extends BaseSDKConfig {
  pixelId: string;
  accessToken: string;
}

// WebView 配置
export interface WebViewConfig extends BaseSDKConfig {
  // WebView 特定配置
}

// ThinkingData 配置
export interface ThinkingDataConfig extends BaseSDKConfig {
  appId: string;
  serverUrl: string;
  showLog?: boolean;
  deviceId?: string;
  autoTrack?: {
    pageShow?: boolean;
    pageHide?: boolean;
  };
}

// ReactNative 配置
export interface ReactNativeConfig extends BaseSDKConfig {
  // ReactNative 特定配置
}

// Tiktok 配置
export interface TiktokConfig extends BaseSDKConfig {
  pixelId: string;
}

// SDK 名称枚举
export enum SDKName {
  GoogleAnalyticsSDK = "GoogleAnalyticsSDK",
  HotjarSDK = "HotjarSDK",
  SentrySDK = "SentrySDK",
  AdjustSDK = "AdjustSDK",
  FacebookSDK = "FacebookSDK",
  WebViewSDK = "WebViewSDK",
  ThinkingDataSDK = "ThinkingDataSDK",
  ReactNativeSDK = "ReactNativeSDK",
  TiktokSDK = "TiktokSDK",
  KwaiSDK = "KwaiSDK",
  GoogleTagManagerSDK = "GoogleTagManagerSDK",
  GlobalGASDK = "GlobalGASDK",
  ChannelGTMSDK = "ChannelGTMSDK",
  OKSpinSDK = "OKSpinSDK",
}
